import React, { createContext, useContext, useState, useEffect } from 'react';

interface ThemeContextType {
    darkMode: boolean;
    toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    // Inicializar con preferencia guardada o modo oscuro por defecto
    const [darkMode, setDarkMode] = useState<boolean>(() => {
        const saved = localStorage.getItem('theme');
        return saved ? saved === 'dark' : false; // Por defecto: modo claro
    });

    useEffect(() => {
        // Guardar preferencia en localStorage
        localStorage.setItem('theme', darkMode ? 'dark' : 'light');

        // Actualizar clase en el body para estilos globales
        if (darkMode) {
            document.documentElement.classList.add('dark');
            document.body.style.backgroundImage = "url('/bg-hero.png')";
        } else {
            document.documentElement.classList.remove('dark');
            document.body.style.backgroundImage = "url('/bg-hero.png')";
        }
    }, [darkMode]);

    const toggleTheme = () => {
        setDarkMode(prev => !prev);
    };

    return (
        <ThemeContext.Provider value={{ darkMode, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
